import React, { Component } from 'react'
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl'
import TextField from 'react-md/lib/TextFields'
import './NewsLetter.css'

class NewsLetter extends Component {
  constructor(props){
    super(props);
    this.state = {
      email: '',
      status: '',
      emailType1: false,
      emailType2: false,
      emailType3: false
    }
  }

  emailTypeHandler1(event) {
    if(this.state.emailType1===false) {
      this.setState({emailType1: true})

      if(this.state.emailType2===true) {
        this.setState({emailType3: true}) 
      }
    }
    else {
      this.setState({emailType1: false})
      this.setState({emailType3: false})
    }
  }

  emailTypeHandler2(event) {
    if(this.state.emailType2===false) {
      this.setState({emailType2: true})

      if(this.state.emailType1===true) {
        this.setState({emailType3: true})
      }
    }
    else {
      this.setState({emailType2: false})
      this.setState({emailType3: false})
    }
  }

  emailHandler(email) {
    this.setState({email: email})
  }

  resetHandler(event) {
    event.preventDefault()
    this.setState({
      email: '',
      status: ''
    })
  }

  subscribeHandler(event) {
    event.preventDefault()

    let t = this

    t.setState({status: ''});

    let type = 'personal'

    if(t.state.emailType1 === true && t.state.emailType3 === false) {
      type = 'personal'
    }
    if(t.state.emailType2 === true && t.state.emailType1 === false) {
      type = 'business'
    }
    if(t.state.emailType3 === true) {
      type = 'both'
    }
    
    fetch('https://campaign.monkfish.fi/bwcm/subscribe.php?email='+this.state.email+'&type='+type)
    .then(function (response) {
      response.text().then(
        function(text)
        {
          if(text === 'success') {
            t.setState({status: 'success'})
          }
          else {
            t.setState({
              status: 'fail',
              emailType1: false,
              emailType2: false,
              emailType3: false
            })
          }
        }
      )
    })
  }

  render(){
    const email = this.state.email
    const status = this.state.status

    const messages = defineMessages({
      placeholder: {
        id: 'newsletter.placeholder'
      }
    })
    return(
      <div className={this.props.classname?this.props.classname:null}>
        {this.props.title && <h3><FormattedMessage id="newsletter.orderTitle" /></h3>}
        {!this.props.title && <h4><FormattedMessage id="newsletter.title" /></h4>}

        <p> <FormattedMessage id="newsletter.text" /> </p>

        {status === '' &&
          <form onSubmit={this.subscribeHandler.bind(this)}>
            <div className="email-type">
              <div>
                <label className="control checkbox"><FormattedMessage id="newsletter.private" />
                  <input type="checkbox" name="email-type" value="private" onChange={this.emailTypeHandler1.bind(this)} />
                  <div className="indicator" />
                </label>
              </div>
              <div>
                <label className="control checkbox"><FormattedMessage id="newsletter.business" />
                  <input type="checkbox" name="email-type" value="business" onChange={this.emailTypeHandler2.bind(this)} />
                  <div className="indicator" />
                </label>
                </div>
            </div>
            <footer>
              <TextField id="email" type="email" label={this.props.intl.formatMessage(messages.placeholder)} onChange={this.emailHandler.bind(this)} value={email} required />
              <button type="submit" disabled={email.length===0?'disabled':''}><FormattedMessage id="newsletter.submit" /></button>
            </footer>
          </form>
        }
        {status === 'success' &&
          <div className="status"><FormattedMessage id="newsletter.success" /></div>
        }
        {status === 'fail' &&
          <div className="status"><FormattedMessage id="newsletter.fail" /> <a href="#nogo" onClick={this.resetHandler.bind(this)}><FormattedMessage id="newsletter.tryAgain" /></a>.</div>
        }
      </div>
    )
  }
}

NewsLetter.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(NewsLetter)


// WEBPACK FOOTER //
// ./src/components/NewsLetter/NewsLetter.js